import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=720bf0dd&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=ts"
export * from "./ExamList.vue?vue&type=script&lang=ts"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=720bf0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720bf0dd",
  null
  
)

export default component.exports